export default "__VITE_ASSET__OWRQvS2U__"